/** @jsx jsx */

import {
  ChartWrapperOptions,
  GoogleChartWrapperChartType,
} from 'react-google-charts';
import { jsx } from '@emotion/core';
import { Dispatch, SetStateAction } from 'react';
import _ from 'lodash';
import { BaseChart } from '../CommonChart/BaseChart';

interface CommonMultiItemsChartProps {
  chartType: GoogleChartWrapperChartType;
  colors?: string[];
  data: unknown[];
  hAxisFormat?: string;
  hAxisLabelConfig?: number;
  optionOverrides?: Partial<ChartWrapperOptions>;
  setHasRenderError: Dispatch<SetStateAction<boolean>>;
  vAxisFormat: string;
  xAxisLabel?: string;
  yAxisLabel?: string;
}

export function CommonMultiItemsChart({
  chartType,
  colors,
  data,
  hAxisFormat,
  hAxisLabelConfig,
  optionOverrides,
  setHasRenderError,
  vAxisFormat,
  xAxisLabel,
  yAxisLabel,
}: CommonMultiItemsChartProps) {
  return (
    <BaseChart
      chartData={data}
      chartType={chartType}
      colors={colors}
      height="375px"
      optionOverrides={_.merge(
        {
          legend: { position: 'bottom' },
          chartArea: {
            top: 5,
            left: 60,
            right: 20,
            width: '100%',
            height: '70%',
          },
          vAxis: {
            title: yAxisLabel,
            format: vAxisFormat,
          },
          hAxis: {
            title: xAxisLabel,
            format: hAxisFormat,
            showTextEvery: hAxisLabelConfig,
          },
        },
        optionOverrides
      )}
      setHasRenderError={setHasRenderError}
    />
  );
}
